import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class BasicWeaveReferenceService extends BaseReferenceService {
  constructor() {
    super('BasicWeaveReference');
  }
}
